export const SymbolTypes = {
    index: 'index',
    stock: 'stock',
};
//# sourceMappingURL=Quote.js.map